<template>
  <div style="height: 85%">
    <ExportTableData
      ref="pobierz"
      :column-defs="columnDefs"
      :grid-options="gridOptions"
    ></ExportTableData>
    <v-layout>
      <v-flex xs7>
        <v-layout class="table--first-row" row wrap>
          <v-flex class="table__wrapper--center">
            <v-icon class="table__btn--green" @click="show('addInvestmentCard')"
              >add_circle</v-icon
            >
            <p class="caption" @click="show('addInvestmentCard')">
              DODAJ INWESTYCJĘ
            </p>
            <v-icon
              style="margin-left: 7px"
              class="table__btn--blue"
              v-show="selectedRow"
              @click="openInvestmentCard"
              >note</v-icon
            >
            <p class="caption" v-show="selectedRow" @click="openInvestmentCard">
              OTWÓRZ KARTĘ
            </p>
          </v-flex>
          <v-spacer />
        </v-layout>
        <v-layout row wrap>
          <v-flex class="table__wrapper--center">
            <v-icon
              @click="
                'pobierz' in $refs && $refs.pobierz.showExportMenu($event)
              "
              class="table__btn--blue"
              >cloud_download</v-icon
            >
            <p
              class="caption"
              @click="
                'pobierz' in $refs && $refs.pobierz.showExportMenu($event)
              "
            >
              POBIERZ REJESTR
            </p>
            <v-icon
              style="margin-left: 9px"
              class="table__btn--padding"
              v-show="selectedRow"
              @click="zoomToGeometry"
              >zoom_in</v-icon
            >
            <p class="caption" v-show="selectedRow" @click="zoomToGeometry">
              PRZYBLIŻ
            </p>
            <v-icon
              style="margin-left:35px"
              class="table__btn--padding table__btn--red"
              v-show="selectedRow"
              @click="deleteRow('')"
              >delete</v-icon
            >
            <p class="caption" v-show="selectedRow" @click="deleteRow('')">
              USUŃ
            </p>
          </v-flex>
          <v-spacer />
        </v-layout>
      </v-flex>
      <v-flex xs5 class="table__wrapper--center table__wrapper--filter">
        <v-layout align-right justify-end>
          <v-text-field
            type="text"
            v-model="filter"
            placeholder="Treść filtra"
            clearable
            :hint="numberFiltered + '/' + numberAll"
            persistent-hint
            filled
          >
          </v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>
    <ag-grid-vue
      class="ag-theme-balham"
      :gridOptions="gridOptions"
      style="height: 90%"
    ></ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import ExportTableData from "../../../shared/ExportTableData";

export default {
  name: "App",
  data: () => ({
    filter: "",
    numberAll: "0", //hint z textfielda wymaga, by wartość była typu string
    numberFiltered: "0", //hint z textfielda wymaga, by wartość była typu string
    selectedRow: undefined,
    statusFilter: "",
    tableTitle: "investmentsTable"
  }),
  components: {
    AgGridVue,
    ExportTableData
  },
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api
        .getModel()
        .rootNode.childrenAfterFilter.length.toString();
    }
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    gridOptions() {
      let gridOptions = {
        rowData: this.loadData(),
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        enableColResize: "true",
        onGridReady: this.onGridReady,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        onFilterChanged: this.filterColumn,
        onSelectionChanged: this.onSelectionChanged,
        rowSelection: "single",
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          lessThan: "Mniejsza niż",
          greaterThan: "Większa niż",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych"
        }
      };
      return gridOptions;
    }
  },
  beforeMount() {
    this.columnDefs = [
      { headerName: "ID", field: "id", sort: "asc" },
      { headerName: "Status", field: "status" },
      { headerName: "Numer działki", field: "address_parcel" },
      { headerName: "Obręb", field: "address_precinct" },
      { headerName: "Miejscowość", field: "address_place" },
      { headerName: "Ulica", field: "address_street" },
      { headerName: "Numer domu", field: "address_order" },
      { headerName: "Opis inwestycji", field: "description_investment" }
    ];
  },
  methods: {
    filterColumn() {
      this.numberFiltered = this.gridOptions.api
        .getModel()
        .rootNode.childrenAfterFilter.length.toString();
    },
    deleteRow(featureName) {
      let payload = {
        oid: this.selectedRow.id,
        feature: featureName
      };
      this.$emit("confDialogOpened", true);
      this.$modal.show("dialog", {
        title: "Usuwanie inwestycji",
        text: "Czy na pewno chcesz usunąć inwestycję?",
        buttons: [
          {
            title: "NIE",
            handler: () => {
              this.$emit("confDialogOpened", false);
              this.$modal.hide("dialog");
              return;
            }
          },
          {
            title: "TAK",
            default: true,
            handler: () => {
              this.$store
                .dispatch("removeInvestmentFeature", payload)
                .then(r => {
                  if (!r) {
                    this.$root.$emit("showSnackbar", "red", `${r}`);
                    return;
                  }
                  this.loadData();
                });
              this.$emit("confDialogOpened", false);
              this.$modal.hide("dialog");
            }
          }
        ]
      });
    },
    loadData() {
      this.$store.dispatch("getInvestments").then(r => {
        this.numberAll = r.investments.length;
        this.numberFiltered = this.numberAll;
        this.gridOptions.api.setRowData(r.investments);
      });
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      if (localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if (columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
    },
    onSelectionChanged() {
      this.selectedRow = this.gridOptions.api.getSelectedRows()[0];
    },
    openInvestmentCard() {
      if (this.activeModals.includes("investmentCardModal")) {
        this.$modal.hide("investmentCardModal");
      }
      setTimeout(() => {
        this.$root.$emit("loadTab", 0);
        this.$root.$emit("loadInvestment", this.selectedRow);
        this.show("investmentCardModal");
      }, 300);
    },
    show(title) {
      if (this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    zoomToGeometry() {
      this.$root.$emit("removeMapLayer");
      this.$root.$emit("zoomToArea", [this.selectedRow.geometry.coordinates]);
      this.$root.$emit(
        "addMapLayer",
        [this.selectedRow.geometry, this.selectedRow.geometry.coordinates],
        "investments"
      );
    }
  },
  mounted() {
    this.$root.$on("updateInvestments", this.loadData);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/investments/InvestmentsTable.vue